import React from 'react'
import { useField } from 'formik'
import { TextField, Typography } from '@material-ui/core'
import { useIntl } from 'react-intl'
import { validateGsm } from 'commons/validateGsm'
import { ErrorIcon } from 'app/components/icons'
import { isNil } from 'ramda'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      border: 0,
    },
    '& fieldset': {
      border: '1px solid #C5C5C5 !important',
    },
    '& input': {
      border: 0,
    },
  },
})

const ShotNameInput = (props) => {
  const { name, maxLenght } = props
  const { formatMessage } = useIntl()
  const classes = useStyles()

  const [field, meta, helpers] = useField(name)
  const { value } = field
  const { setValue, setTouched } = helpers

  const isError = !isNil(meta.error) && meta.touched

  const countValue = value ? value.length : 0

  return (
    <div>
      <div className="relative">
        <TextField
          id={`${name}-input`}
          label={`${formatMessage({
            id: 'profile.info.placeSms.textfield.label',
          })} *`}
          variant="outlined"
          className={clsx(
            'w-full bg-white ',
            classes.root,
            isError
              ? 'border border-red-500 hover:border-red-500'
              : 'border border-grey-input hover:border-grey-input',
          )}
          value={value ?? ''}
          inputProps={{ maxLength: maxLenght }}
          onKeyDown={(event) => {
            if (!validateGsm('', event.key)) {
              event.preventDefault()
            }
          }}
          onChange={(event) => {
            setTouched(true)
            setValue(event.target.value)
          }}
        />
        <Typography
          variant="caption"
          color="textSecondary"
          className={
            'absolute bottom-0 rtl:left-0 rtl:pb-4 rtl:pl-8 ltr:right-0 ltr:pb-4 ltr:pr-8'
          }
        >
          {`${countValue}/${maxLenght}`}
        </Typography>
      </div>
      {isError && (
        <div className="flex space-x-2 py-1">
          <div className="flex my-auto">
            <ErrorIcon classes="w-14" />
          </div>
          <label className="text-red">{meta.error}</label>
        </div>
      )}
    </div>
  )
}

export default React.memo(ShotNameInput)
